import "./styles.less";

import { Avatar, Drawer, Grid, Popover, Space, Typography } from "antd";
import React, { useState } from "react";

import { SchoolIcon } from "../../../CustomIcons/SchoolIcon/web";
import { TooltipPlacement } from "antd/lib/tooltip";
import { useTheme } from "../../../../Styles/ThemeHook";

const { useBreakpoint } = Grid;

export const SchoolMarker = ({
	mapCenter: { latitude: cLat, longitude: cLng },
	lat,
	lng,
	name,
	address,
	photo,
	status = "open",
}: {
	mapCenter: { latitude: number; longitude: number };
	lat: number;
	lng: number;
	name: string;
	address: string;
	photo: string;
	status: "closed" | "open";
}) => {
	const { theme } = useTheme();
	const [visible, setVisible] = useState(false);
	const screens = useBreakpoint();

	const background =
		status == "closed"
			? theme.colors.errorColor
			: visible
			? theme.colors.secondaryHoverColor
			: theme.colors.secondaryColor;

	const title = (
		<Space size={theme.spacing.mdSpacing} direction={"horizontal"} align={"center"}>
			<SchoolIcon
				style={{ fontSize: 20, color: theme.colors.secondaryColor, paddingTop: 4 }}
			/>
			<Typography.Text strong>{name}</Typography.Text>
		</Space>
	);
	const content = (
		<Space direction={"horizontal"} size={theme.spacing.mdSpacing} align={"center"}>
			<Avatar
				alt="School"
				src={photo}
				size={"large"}
				children={name.split(" ")[0]}
				style={{ backgroundColor: theme.colors.secondaryColor }}
			/>
			<Typography.Text>
				{"Dirección" + ": " + address}
				<br />
				{status == "open" ? "ABIERTO" : "CERRADO"}
			</Typography.Text>
		</Space>
	);

	const getPopoverPlacement = (): TooltipPlacement => {
		const h = cLat < lat ? "bottom" : "top";
		const w = cLng < lng ? "Right" : "Left";
		// @ts-ignore
		return h + w;
	};
	return (
		<>
			<Popover
				placement={getPopoverPlacement()}
				visible={visible && !screens.xs}
				content={content}
				title={title}
				trigger="click"
				overlayClassName="map-marker-school-popover"
				overlayStyle={{ maxWidth: 300 }}
				onVisibleChange={e => setVisible(e)}>
				<div className={"map-marker-school " + status} onClick={() => setVisible(true)}>
					<SchoolIcon style={{ fontSize: 18, color: theme.colors.backgroundColor }} />
				</div>
			</Popover>
			<Drawer
				headerStyle={{ padding: theme.spacing.mdSpacing }}
				bodyStyle={{ padding: theme.spacing.mdSpacing }}
				title={title}
				visible={visible && screens.xs}
				placement={"bottom"}
				height={"auto"}
				maskStyle={{ backgroundColor: "transparent" }}
				onClose={() => setVisible(false)}>
				{content}
			</Drawer>
			<style jsx>
				{`
					.map-marker-school {
						background-color: ${background};
						border: 2px solid ${background};
					}
				`}
			</style>
		</>
	);
};
